import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import MultiSelect from '@adv-mt/mt-form-filter-multi-select'

import {ICONS_BY_ENVIRONMENTAL_LABEL} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormEnvironmentalLabel = ({
  initialSearch = {},
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = [0],
  withLabel,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {environmentalLabels, FILTER_NAMES} = config.get('search')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const localizeOptionsLabel = option => ({
    ...option,
    label: i18n.t(option.label)
  })

  const localizedEnvironmentalLabels = environmentalLabels.map(localizeOptionsLabel)

  const placeholder = i18n.t('COMMON.ALL_FEM')

  const _handleOnChange = (e, {value}) => {
    const environmentalLabelsIds = Array.isArray(value) ? value : [value]

    const environmentalLabelsInitialSearch = initialSearch[FILTER_NAMES.ENVIRONMENTAL_LABEL]

    const hasLastFilter = environmentalLabelsInitialSearch?.every(environmentalLabelsId =>
      environmentalLabelsIds.includes(environmentalLabelsId)
    )

    onChange(e, {
      field: FILTER_NAMES.ENVIRONMENTAL_LABEL,
      value,
      lastFilter: hasLastFilter && TRACKING_FILTER_NAMES[FILTER_NAMES.ENVIRONMENTAL_LABEL]
    })
  }

  const label = i18n.t('COMMON.ENVIRONMENTAL_LABEL')

  const getEnviromentLabelSelected = ({environmentalLabel, value}) => {
    const valueSet = new Set(value.map(String))

    return environmentalLabel
      .filter(item => valueSet.has(item.id))
      .map(item => item.label)
      .join(', ')
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <MultiSelect
        field={FILTER_NAMES.ENVIRONMENTAL_LABEL}
        initialSearch={initialSearch}
        label={label}
        options={localizedEnvironmentalLabels}
        value={value}
        placeholder={placeholder}
        onChange={_handleOnChange}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
      />
    )
  }
  return (
    <div className="mt-formEnvironmentalLabel">
      <FilterWrapperBasic
        filters={[
          {
            allSelectionsLabel: i18n.t('COMMON.ALL_FEM'),
            label: i18n.t('COMMON.ENVIRONMENTAL_LABEL'),
            name: FILTER_NAMES.ENVIRONMENTAL_LABEL,
            options: localizedEnvironmentalLabels.map(item => ({
              ...item,
              element: (
                <AtomImage
                  className={'mt-formEnvironmentalLabel-icon'}
                  src={`${URL_STATICS_IMAGES}${ICONS_BY_ENVIRONMENTAL_LABEL[item.id]}`}
                  alt=""
                />
              )
            })),
            showLabel: true,
            type
          }
        ]}
        group={`${FILTER_NAMES.ENVIRONMENTAL_LABEL}Group`}
        legend={i18n.t('COMMON.ENVIRONMENTAL_LABEL')}
        onChange={({value}) => {
          _handleOnChange(null, {value: value.filter(id => id !== allSelectionsId)})
        }}
        overlayContentRef={overlayContentRef}
        placeholder={
          value.length
            ? getEnviromentLabelSelected({environmentalLabel: localizedEnvironmentalLabels, value})
            : i18n.t('COMMON.ALL_FEM')
        }
        showLegend={withLabel}
        value={{
          [FILTER_NAMES.ENVIRONMENTAL_LABEL]: value.length ? value.map(value => String(value)) : [allSelectionsId]
        }}
        wrapper={wrapper}
      />
    </div>
  )
}

FormEnvironmentalLabel.displayName = 'FormEnvironmentalLabel'
FormEnvironmentalLabel.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default memo(FormEnvironmentalLabel)
